'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordRegExps = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _isEmpty3 = require('lodash/isEmpty');

var _isEmpty4 = _interopRequireDefault(_isEmpty3);

exports.email = email;
exports.password = password;
exports.passwordCondition = passwordCondition;
exports.required = required;
exports.minLength = minLength;
exports.maxLength = maxLength;
exports.integer = integer;
exports.oneOf = oneOf;
exports.match = match;
exports.createValidator = createValidator;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Validation rules and regexps for forms */

var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || value === '';
};
var join = function join(rules) {
  return function (value, data) {
    return rules.map(function (rule) {
      return rule(value, data);
    }).filter(function (error) {
      return !!error;
    })[0];
  };
};

var passwordRegExps = exports.passwordRegExps = {
  all: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&=\-+~#()^:,."'\\/_]).{8,}/,
  uppercase: /[A-Z]/,
  lowercase: /[a-z]/,
  number: /[\d]/,
  symbol: /[$@$!%*?&=\-+~#()^:,."'\\/_]/,
  length: /.{8}/
};

function email(value) {
  var t = require('i18n-universal').getT();
  // Let's not start a debate on email regex. This is just for an example app!
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return t('Invalid email address');
  }
}

function password(value) {
  var t = require('i18n-universal').getT();
  if (!isEmpty(value) && !passwordRegExps.all.test(value)) {
    return t('Invalid password');
  } else if (isEmpty(value)) {
    return t('Required');
  }
}

function passwordCondition(value) {
  var t = require('i18n-universal').getT();
  var errors = {};

  if (!(0, _isEmpty4.default)(value)) {
    if (!passwordRegExps.uppercase.test(value)) {
      errors.uppercase = t('Password should contain at least one uppercase character');
    }
    if (!passwordRegExps.lowercase.test(value)) {
      errors.lowercase = t('Password should contain at least one lowercase character');
    }
    if (!passwordRegExps.number.test(value)) {
      errors.number = t('Password should contain at least one number');
    }
    if (!passwordRegExps.symbol.test(value)) {
      errors.symbol = t('Password should contain at least one special symbol');
    }
    if (!passwordRegExps.length.test(value)) {
      errors.length = t('Password length should be minimum 8 characters');
    }
  }

  return (0, _isEmpty4.default)(errors) ? null : errors;
}

function required(value) {
  if (isEmpty(value)) {
    var t = require('i18n-universal').getT();
    return t('Required');
  }
}

function minLength(min) {
  return function (value) {
    if (!isEmpty(value) && value.length < min) {
      var t = require('i18n-universal').getT();
      return t('Must be at least {{count}} characters', { count: min });
    }
  };
}

function maxLength(max) {
  return function (value) {
    if (!isEmpty(value) && value.length > max) {
      var t = require('i18n-universal').getT();
      return t('Must be no more than {{count}} characters', { count: max });
    }
  };
}

function integer(value) {
  if (!(0, _isInteger2.default)(Number(value))) {
    var t = require('i18n-universal').getT();
    return t('Must be an integer');
  }
}

function oneOf(enumeration) {
  return function (value) {
    if (enumeration.indexOf(value) === -1) {
      var t = require('i18n-universal').getT();
      return t('Must be one of: {{oneOf}}', { oneOf: enumeration.join(', ') });
    }
  };
}

function match(field) {
  return function (value, data) {
    if (data) {
      if (value !== data[field]) {
        var t = require('i18n-universal').getT();
        return t('Do not match');
      }
    }
  };
}

function createValidator(rules) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var errors = {};
    (0, _keys2.default)(rules).forEach(function (key) {
      var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      var error = rule(data[key], data);
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/validation.js
// module id = 157
// module chunks = 1